<template>
  <div class="pg-404">
    <div class="error">
      <div class="title" v-if="authorityCheckResult==0">403:此模块属于收费模块，未经授权不能使用！</div>
      <div class="title" v-if="authorityCheckResult==2">403:没有当前页面权限，请联系管理员</div>
      <svg
        height="100%"
        node-id="1"
        sillyvg="true"
        template-height="800"
        template-width="800"
        version="1.1"
        viewBox="0 0 800 800"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <defs node-id="52">
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_1_"
            node-id="16"
            spreadMethod="pad"
            x1="399.1042"
            x2="399.1042"
            y1="519.3132"
            y2="668.952"
          >
            <stop offset="0" stop-color="#d4dbe5"></stop>
            <stop offset="1" stop-color="#ffffff"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_2_"
            node-id="20"
            spreadMethod="pad"
            x1="391.1811"
            x2="391.1811"
            y1="448.3349"
            y2="133.9841"
          >
            <stop offset="0.1119" stop-color="#ffffff"></stop>
            <stop offset="0.9205" stop-color="#e2e6ed"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_3_"
            node-id="24"
            spreadMethod="pad"
            x1="147.4465"
            x2="147.4465"
            y1="373.282"
            y2="342.8969"
          >
            <stop offset="0.1119" stop-color="#f1f3f6"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_4_"
            node-id="28"
            spreadMethod="pad"
            x1="599.0583"
            x2="599.0583"
            y1="286.7823"
            y2="243.655"
          >
            <stop offset="0.1119" stop-color="#f1f3f6"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientTransform="matrix(0 -1 1 0 3069.8447 -14172.7695)"
            gradientUnits="userSpaceOnUse"
            id="SVGID_5_"
            node-id="32"
            spreadMethod="pad"
            x1="-14744.78"
            x2="-14744.78"
            y1="-2480.098"
            y2="-2504.602"
          >
            <stop offset="0.1119" stop-color="#f1f3f6"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_6_"
            node-id="37"
            spreadMethod="pad"
            x1="387.8401"
            x2="387.8401"
            y1="594.1467"
            y2="239.2039"
          >
            <stop offset="0.1119" stop-color="#c2cfdd"></stop>
            <stop offset="0.9205" stop-color="#dae0e8"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_7_"
            node-id="41"
            spreadMethod="pad"
            x1="322.3256"
            x2="485.5733"
            y1="269.6922"
            y2="552.4454"
          >
            <stop offset="0.0884" stop-color="#ebeef2"></stop>
            <stop offset="1" stop-color="#d2d9e3"></stop>
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="SVGID_8_"
            node-id="45"
            spreadMethod="pad"
            x1="344.3164"
            x2="444.334"
            y1="421.1354"
            y2="421.1354"
          >
            <stop offset="0.1119" stop-color="#cad5e2"></stop>
            <stop offset="0.9205" stop-color="#d2d9e3"></stop>
          </linearGradient>
        </defs>
        <g node-id="127">
          <g node-id="128">
            <path
              d="M 693.64 594.13 C 693.64 635.45 561.77 668.95 399.10 668.95 C 236.43 668.95 104.56 635.45 104.56 594.13 C 104.56 552.81 236.43 519.31 399.10 519.31 C 561.77 519.31 693.64 552.81 693.64 594.13 Z"
              fill="url(#SVGID_1_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="108"
              stroke="none"
              target-height="149.64001"
              target-width="589.08"
              target-x="104.56"
              target-y="519.31"
            ></path>
            <path
              d="M 568.40 270.47 L 568.40 151.20 L 544.47 133.98 L 439.90 175.56 L 439.90 297.35 L 415.96 297.35 L 415.96 263.75 L 370.18 263.75 L 370.18 295.25 L 348.35 295.25 L 348.35 236.45 L 308.87 236.45 L 308.87 340.60 L 297.95 340.60 L 297.95 157.08 L 204.72 157.08 L 204.72 325.49 L 157.26 325.49 L 157.26 387.86 L 129.97 387.86 L 129.97 448.33 L 652.40 448.33 L 652.40 443.49 L 652.40 387.86 L 652.40 270.47 Z"
              fill="url(#SVGID_2_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="110"
              stroke="none"
              target-height="314.34998"
              target-width="522.43005"
              target-x="129.97"
              target-y="133.98"
            ></path>
            <path
              d="M 162.64 358.09 C 162.64 366.48 155.84 373.28 147.45 373.28 C 139.06 373.28 132.26 366.48 132.26 358.09 C 132.26 349.70 139.06 342.90 147.45 342.90 C 155.84 342.90 162.64 349.70 162.64 358.09 Z"
              fill="url(#SVGID_3_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="112"
              stroke="none"
              target-height="30.380005"
              target-width="30.380005"
              target-x="132.26"
              target-y="342.9"
            ></path>
            <path
              d="M 620.62 265.22 C 620.62 277.13 610.97 286.78 599.06 286.78 C 587.15 286.78 577.50 277.13 577.50 265.22 C 577.50 253.31 587.15 243.66 599.06 243.66 C 610.97 243.66 620.62 253.31 620.62 265.22 Z"
              fill="url(#SVGID_4_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="114"
              stroke="none"
              target-height="43.119995"
              target-width="43.119995"
              target-x="577.5"
              target-y="243.66"
            ></path>
            <path
              d="M 589.74 572.01 C 589.74 578.78 584.26 584.26 577.49 584.26 C 570.72 584.26 565.24 578.78 565.24 572.01 C 565.24 565.24 570.72 559.76 577.49 559.76 C 584.26 559.76 589.74 565.24 589.74 572.01 Z"
              fill="url(#SVGID_5_)"
              fill-rule="nonzero"
              group-id="1,2"
              node-id="116"
              stroke="none"
              target-height="24.5"
              target-width="24.5"
              target-x="565.24"
              target-y="559.76"
            ></path>
          </g>
          <g node-id="129">
            <path
              d="M 538.09 380.82 C 538.09 356.34 538.12 331.87 538.08 307.39 C 538.06 293.04 533.79 289.06 519.87 286.90 C 477.44 280.30 436.74 268.21 400.37 244.67 C 389.85 237.86 381.83 237.09 370.92 244.20 C 335.60 267.22 296.68 281.26 254.84 286.93 C 241.55 288.73 237.78 292.80 237.77 306.14 C 237.73 351.78 238.17 397.43 237.58 443.07 C 237.24 469.80 245.86 492.98 261.92 513.68 C 293.80 554.78 337.81 577.34 385.77 593.58 C 388.30 594.44 391.68 594.25 394.24 593.35 C 433.23 579.63 469.82 561.56 499.79 532.35 C 523.07 509.65 538.13 482.87 538.08 449.26 C 538.06 426.46 538.08 403.64 538.09 380.82 Z"
              fill="url(#SVGID_6_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="121"
              stroke="none"
              target-height="357.35"
              target-width="300.89"
              target-x="237.24"
              target-y="237.09"
            ></path>
            <path
              d="M 538.09 391.86 C 538.09 368.65 538.12 345.44 538.08 322.23 C 538.06 308.62 534.02 304.85 520.85 302.80 C 480.70 296.54 442.18 285.08 407.78 262.76 C 397.83 256.30 390.23 255.58 379.92 262.32 C 346.50 284.15 309.67 297.46 270.08 302.84 C 257.50 304.55 253.94 308.40 253.93 321.06 C 253.90 364.34 254.31 407.63 253.75 450.90 C 253.42 476.24 261.58 498.23 276.78 517.86 C 306.95 556.84 348.59 578.22 393.97 593.63 C 396.37 594.44 399.56 594.27 401.98 593.41 C 438.87 580.40 473.50 563.27 501.85 535.57 C 523.88 514.05 538.13 488.66 538.08 456.79 C 538.06 435.15 538.08 413.50 538.09 391.86 Z"
              fill="url(#SVGID_7_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="123"
              stroke="none"
              target-height="338.86"
              target-width="284.71002"
              target-x="253.42"
              target-y="255.58"
            ></path>
            <path
              d="M 406.33 429.45 C 428.13 424.06 444.34 404.35 444.34 380.91 C 444.34 353.33 421.91 330.90 394.33 330.90 C 366.75 330.90 344.32 353.33 344.32 380.91 C 344.32 404.35 360.53 424.06 382.33 429.45 L 382.33 511.37 L 406.33 511.37 L 406.33 476.40 L 437.06 476.40 L 437.06 452.40 L 406.33 452.40 L 406.33 429.45 Z M 368.32 380.91 C 368.32 366.57 379.99 354.90 394.33 354.90 C 408.67 354.90 420.34 366.57 420.34 380.91 C 420.34 395.25 408.67 406.92 394.33 406.92 C 379.99 406.92 368.32 395.25 368.32 380.91 Z"
              fill="url(#SVGID_8_)"
              fill-rule="nonzero"
              group-id="1,3"
              node-id="125"
              stroke="none"
              target-height="180.47"
              target-width="100.01999"
              target-x="344.32"
              target-y="330.9"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage403',
  data() {
    return {
      authorityCheckResult: 1 // -1:网络异常  0:验证不通过（没有收费权限）  1:验证通过（收费权限和页面权限）  2:没有页面权限
    }
  },
  mounted () {
    this.authorityCheckResult = this.$route.params.authorityCheckResult
  }
}
</script>

<style scoped>
.pg-404 {
  height: auto;
  margin: 0 auto;
  height: auto;
  width: 50%;
  margin: 0 25%;
}
.error {
  flex-wrap: nowrap;
  font-size: 20px;
  text-align: center;
  font-weight: 300;
}
.title {
  padding-top: 20px;
  color: #999;
  font-weight: 400;
}
</style>
